(function() {
    'use strict';

    angular
        .module('app.layout')
        .directive('sponsorsSections', sponsorsSections);

    /* @ngInject */
    function sponsorsSections() {
        var directive = {
            bindToController: true,
            templateUrl: 'sponsors-sections.tpl',
            controller: sponsorsSectionsController,
            controllerAs: 'vm',
            link: link,
            restrict: 'E',
            scope: {
                data: '='
            }
        };
        return directive;

        function link(scope, element, attrs) {
        }

    }

    /* @ngInject */
    function sponsorsSectionsController () {
    }
})();